import styled from 'styled-components'
export const HorizontallyAlignedComponent = styled.div`
   {
    display: flex;
    vertical-align: middle;
    align-items: center;
  }
`
